import StyledMain from "./styled-main";

const Main = (props) => {
  return <StyledMain {...props} />;
};

Main.displayName = "SectionMain";

export default Main;
